import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { mt } from '@nib/layout';
import { copyFontFamily, formErrorMessageColor, formInfoMessageColor, token } from '@nib-components/theme';
import { disabledOpacity } from '../disabled';
import FullStoryMask from '../FullStoryMask';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Message = styled(_ref => {
  let {
    shouldDisplay,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
})`
  ${mt(2)};

  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s;

  @media (prefers-reduced-motion: reduce) {
    .animation {
      transition: none;
    }
  }

  ${_ref2 => {
  let {
    shouldDisplay
  } = _ref2;
  return shouldDisplay && `
    max-height: 80px;
  `;
}};
`;
Message.displayName = 'Message';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const MessageText = styled(_ref3 => {
  let {
    type,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
})`
  color: ${_ref4 => {
  let {
    type
  } = _ref4;
  return type === 'error' ? token('theme.color.fg.error', formErrorMessageColor) : type === 'info' ? token('theme.color.fg.info', formInfoMessageColor) : 'inherit';
}};
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 700;
  font-family: ${copyFontFamily};

  ${_ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled && css`
      opacity: ${disabledOpacity};
    `;
}};
`;
MessageText.displayName = 'MessageText';
export const ErrorMessage = props => {
  const {
    error = '',
    valid = false,
    id,
    disabled,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(Message, {
    shouldDisplay: !valid,
    disabled: disabled,
    ...otherProps,
    "data-mesh-component": "FORM-CONTROL--ERROR-MESSAGE",
    children: /*#__PURE__*/_jsx(MessageText, {
      type: "error",
      id: `error-${id}`,
      "aria-live": "polite",
      disabled: disabled,
      children: error
    })
  });
};
ErrorMessage.displayName = 'ErrorMessage';
export const InfoMessage = props => {
  const {
    info = '',
    valid,
    id,
    disabled,
    fullstory,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(Message, {
    shouldDisplay: valid && info && info.length,
    disabled: disabled,
    ...otherProps,
    "data-mesh-component": "FORM-CONTROL--INFO-MESSAGE",
    children: /*#__PURE__*/_jsx(MessageText, {
      type: "info",
      id: `info-${id}`,
      "aria-live": "polite",
      disabled: disabled,
      children: /*#__PURE__*/_jsx(FullStoryMask, {
        level: fullstory,
        children: info
      })
    })
  });
};
InfoMessage.displayName = 'InfoMessage';